// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._bookingRequest_27vxh_1 {
  --pa-booking-request-padding-left-lg-inner: var(--pa-booking-request-padding-left-lg, 151px);
  --pa-booking-request-padding-right-lg-inner: var(--pa-booking-request-padding-right-lg, 151px);
  --pa-booking-request-padding-left-xl-inner: var(--pa-booking-request-padding-left-xl, 178px);
  --pa-booking-request-padding-right-xl-inner: var(--pa-booking-request-padding-right-xl, 178px);
  --pa-booking-request-padding-left-xxl-inner: var(--pa-booking-request-padding-left-xxl, 226px);
  --pa-booking-request-padding-right-xxl-inner: var(--pa-booking-request-padding-right-xxl, 226px);
}
@media (min-width: 992px) and (max-width: 1199px) {
  ._bookingRequest_27vxh_1 {
    padding-left: var(--pa-booking-request-padding-left-lg-inner);
    padding-right: var(--pa-booking-request-padding-right-lg-inner);
  }
}
@media (min-width: 1200px) and (max-width: 1599px) {
  ._bookingRequest_27vxh_1 {
    padding-left: var(--pa-booking-request-padding-left-xl-inner);
    padding-right: var(--pa-booking-request-padding-right-xl-inner);
  }
}
@media (min-width: 1600px) {
  ._bookingRequest_27vxh_1 {
    padding-left: var(--pa-booking-request-padding-left-xxl-inner);
    padding-right: var(--pa-booking-request-padding-right-xxl-inner);
  }
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
